$(".extended-banner-title").before("<span>" + bannerText + "</span>");
$(".extended-banner-texts").append($(".openBox").clone());

if($('.in-index').length){
    $(function () {
    var $main = $('main.content');
    var $headings = $main.find('.homepage-group-title.h4');

    // Ochrana proti opakovanému spuštění a kontrola existence skupin.
    if (!$headings.length || $main.find('.bakery-tabs').length) {
        return;
    }

    var $firstHeading = $headings.first();
    var $tabs = $('<div>', {
        class: 'bakery-tabs',
        'data-bakery-tabs': ''
    });

    var $header = $('<div>', { class: 'bakery-tabs__header' });
    var $title = $('<h4>', {
        class: 'bakery-tabs__title',
        text: 'Naše nabídka'
    });
    var $nav = $('<ul>', {
        class: 'bakery-tabs__nav',
        role: 'tablist',
        'aria-label': 'Kategorie pečiva'
    });
    var $panels = $('<div>', { class: 'bakery-tabs__panels' });

    $header.append($title, $nav);
    $tabs.append($header, $panels);
    $firstHeading.before($tabs);

    $headings.each(function (index) {
        var $heading = $(this);
        var $products = $heading.next('.products.products-block');

        if (!$products.length) {
            return;
        }

        var tabId = 'bakery-tab-' + index;
        var panelId = 'bakery-panel-' + index;
        var title = $.trim($heading.text());
        var isActive = index === 0;

        var $tabItem = $('<li>', { role: 'presentation' });
        var $tabButton = $('<button>', {
            type: 'button',
            id: tabId,
            class: 'bakery-tabs__button' + (isActive ? ' is-active' : ''),
            role: 'tab',
            'aria-controls': panelId,
            'aria-selected': isActive ? 'true' : 'false',
            tabindex: isActive ? '0' : '-1',
            text: title
        });

        var $panel = $('<div>', {
            id: panelId,
            class: 'bakery-tabs__panel' + (isActive ? ' is-active' : ''),
            role: 'tabpanel',
            'aria-labelledby': tabId,
            'aria-hidden': isActive ? 'false' : 'true'
        });

        $tabItem.append($tabButton);
        $nav.append($tabItem);

        // Přemístí původní Shoptet produktový blok do odpovídající záložky.
        $panel.append($products);
        $panels.append($panel);

        // Původní nadpis už nahrazuje tlačítko záložky.
        $heading.remove();
    });

    var $footer = $('<div class="text-center bakery-tabs__footer">');
    var $allButton = $('<a>', {
        class: 'btn btn-secondary',
        href: odkaznacelouNabidku, // Upravte na URL stránky s celou nabídkou.
        text: 'Celá naše nabídka'
    });

    $footer.append($allButton);
    $tabs.append($footer);

    function activateTab($button) {
        var targetId = $button.attr('aria-controls');

        $nav.find('.bakery-tabs__button')
            .removeClass('is-active')
            .attr({
                'aria-selected': 'false',
                tabindex: '-1'
            });

        $panels.find('.bakery-tabs__panel')
            .removeClass('is-active')
            .attr('aria-hidden', 'true');

        $button
            .addClass('is-active')
            .attr({
                'aria-selected': 'true',
                tabindex: '0'
            });

        $('#' + targetId)
            .addClass('is-active')
            .attr('aria-hidden', 'false');

        // Některé Shoptet prvky potřebují po zobrazení přepočítat rozměry.
        $(window).trigger('resize');
    }

    $nav.on('click', '.bakery-tabs__button', function () {
        activateTab($(this));
    });

    $nav.on('keydown', '.bakery-tabs__button', function (event) {
        var $buttons = $nav.find('.bakery-tabs__button');
        var currentIndex = $buttons.index(this);
        var nextIndex = currentIndex;

        if (event.key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % $buttons.length;
        } else if (event.key === 'ArrowLeft') {
            nextIndex = (currentIndex - 1 + $buttons.length) % $buttons.length;
        } else if (event.key === 'Home') {
            nextIndex = 0;
        } else if (event.key === 'End') {
            nextIndex = $buttons.length - 1;
        } else {
            return;
        }

        event.preventDefault();
        activateTab($buttons.eq(nextIndex));
        $buttons.eq(nextIndex).trigger('focus');
    });
});
}
